// src/pages/TagalogHomePage.jsx
import React from 'react';
import PrayerButtonGrid from '../components/PrayerButtonGrid';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const categories = [
  'daily',
  'christian',
  'catholic',
  'father',
  'mother',
  'wife_prayer',
  'husband_prayer',
  'son_prayer',
  'daughter_prayer',
  'brother_prayer',
  'sister_prayer',
  'friend_prayer',
  'health_prayer',
  'finances_prayer',
  'world_prayer',
  'extended_family_prayer'
];

const labels = {
  daily: 'Araw-araw',
  christian: 'Kristiyano',
  catholic: 'Katoliko',
  father: 'Tatay',
  mother: 'Nanay',
  wife_prayer: 'Asawa (Babae)',
  husband_prayer: 'Asawa (Lalaki)',
  son_prayer: 'Anak na Lalaki',
  daughter_prayer: 'Anak na Babae',
  brother_prayer: 'Kapatid na Lalaki',
  sister_prayer: 'Kapatid na Babae',
  friend_prayer: 'Kaibigan',
  health_prayer: 'Kalusugan',
  finances_prayer: 'Pananalapi',
  world_prayer: 'Mundo',
  extended_family_prayer: 'Pinalawak na Pamilya'
};

function TagalogHomePage() {
  const navigate = useNavigate();

  return (
    <Container className="mt-4">
      <h1 className="text-center mb-4">Pumili ng Panalangin</h1>
      <PrayerButtonGrid
        categories={categories}
        labels={labels}
        onSelect={(cat) => navigate(`/tl/prayer/${cat}`, { state: { from: '/tl' } })}
      />


      {/* ➕ More Prayers Button */}
      <div className="text-center mt-3">
        <Button className="glass-button bg-transparent border-0" onClick={() => navigate('/tl/more')}>
          Marami Pang Panalangin
        </Button>
      </div>
    </Container>
  );
}

export default TagalogHomePage;
